import TextField from "@mui/material/TextField";
import "../styles/formContains.css";
import { Button, Checkbox, FormControlLabel, MenuItem } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import axios, { AxiosError } from "axios";
import ModalPolitics from "../politics/modalPolitic";
import ModalConduct from "../politics/modalConducta";

interface dataEmailFranca {
  subject: string;
  name: string;
  email: string;
  message: string;
  politics: boolean;
}

const asuntoOptions = [
  {
    value: "Felicitación",
    label: "Felicitación",
  },
  {
    value: "Queja",
    label: "Queja",
  },
  {
    value: "Reclamo",
    label: "Reclamo",
  },
  {
    value: "Sugerencia",
    label: "Sugerencia",
  },

  {
    value: "Solicitud",
    label: "Solicitud",
  },
];

export default function FormComplains() {
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
  } = useForm<dataEmailFranca>({
    defaultValues: {
      subject: "",
      email: "",
      name: "",
      message: "",
      politics: false,
    },
  });

  const availablePolitics = () => {
    setValue("politics", true);
  };
  const submitEmail = async (data: dataEmailFranca) => {
    const dataAdapter = {
      name: data.name,
      email: data.email,
      message: data.message,
      subject: data.subject,
      agree: data.politics,
      pqr: true,
    };

    try {
      const renponseFranca = await axios({
        method: "post",
        url: "https://franca.agency/backend-franca/index.php",
        data: dataAdapter,
      });

      setValue("politics", false);

      toast.success(renponseFranca.data.message);
      reset();
    } catch (error) {
      // Tipar el error como AxiosError
      if (error instanceof AxiosError) {
        // Acceder a propiedades específicas del error de Axios
        console.error("Error message:", error.message);

        if (error.response) {
          // El servidor respondió con un código de error
          console.error("Response data:", error.response.data.error);
          console.error("Status code:", error.response.status);

          toast.error(error.response.data.error[1]);
        } else if (error.request) {
          // La solicitud se realizó pero no hubo respuesta
          console.error("Request:", error.request);
        } else {
          // Ocurrió otro tipo de error
          console.error("Error:", error.message);
        }
      } else {
        // Si no es un AxiosError, manejar el error genérico
        console.error("Unexpected error:", error);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(submitEmail)}>
      <div className="formComplainsContainer">
        <Controller
          name={"name"}
          control={control}
          rules={{ required: "Nombre es requerido" }}
          render={({ field: { onChange, value } }) => (
            <TextField
              id="standard-basic"
              label="Nombre"
              variant="standard"
              value={value}
              className="textFieldCustom"
              color="success"
              onChange={onChange}
              error={errors.name ? true : false}
              helperText={errors.name?.message}
            />
          )}
        />

        <Controller
          name={"subject"}
          control={control}
          rules={{ required: "Asunto es requerido" }}
          render={({ field: { onChange, value } }) => (
            <TextField
              id="standard-select-currency"
              select
              label="Asunto"
              className="textFieldCustom"
              value={value}
              color="success"
              onChange={onChange}
              variant="standard"
              error={errors.subject ? true : false}
              helperText={errors.subject?.message}
            >
              {asuntoOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <p style={{ margin: "2px 4px" }}>{option.label}</p>
                </MenuItem>
              ))}
            </TextField>
          )}
        />

        <Controller
          name={"email"}
          control={control}
          rules={{ required: "Email es requerido" }}
          render={({ field: { onChange, value } }) => (
            <TextField
              id="standard-basic"
              label="Email"
              variant="standard"
              value={value}
              className="textFieldCustom"
              color="success"
              onChange={onChange}
              error={errors.email ? true : false}
              helperText={errors.email?.message}
            />
          )}
        />

        <Controller
          name={"message"}
          control={control}
          rules={{ required: "Mensaje es requerido" }}
          render={({ field: { onChange, value } }) => (
            <TextField
              className="textFieldCustom"
              id="outlined-multiline-static"
              label="Mensaje"
              color="success"
              multiline
              rows={4}
              value={value}
              onChange={onChange}
              error={errors.message ? true : false}
              helperText={errors.message?.message}
            />
          )}
        />

        <div style={{ display: "flex", flexDirection: "column" }}>
          <FormControlLabel
            control={
              <Controller
                name={"politics"}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Checkbox
                    color="success"
                    onChange={onChange}
                    checked={value}
                  />
                )}
              />
            }
            label="Aceptar polica de datos"
          />
          <ModalPolitics availablePolitics={availablePolitics} />
          <ModalConduct/>
        </div>

        <div>
          <Button variant="contained" color="success" type="submit">
            Enviar
          </Button>
        </div>
      </div>
    </form>
  );
}
